import http from './http';

export default {
  all() {
    return http().get(`/v1/imports`);
  },
  get(id) {
    return http().get(`/v1/imports/${id}`);
  },
  deleteDuplicates(id, record_id) {
    return http().delete(`/v1/imports/${id}/duplicate-leads/${record_id}`);
  },
  getDuplicates(id) {
    return http().get(`/v1/imports/${id}/duplicate-leads`);
  },
  create(data) {
    return http().post(`/v1/imports`, data);
  },
  import(id) {
    return http().put(`/v1/imports/${id}/import`);
  },
  rollback(id) {
    return http().put(`/v1/imports/${id}/rollback`);
  },
  delete(id) {
    return http().delete(`/v1/imports/${id}`);
  }
}
